import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import StarRatings from '@deal/react-star-ratings';

var StarRating = function StarRating(_a) {
  var _b = _a.starRatedColor,
      starRatedColor = _b === void 0 ? 'rgb(245, 87, 0)' : _b,
      _c = _a.starSpacing,
      starSpacing = _c === void 0 ? '0px' : _c,
      _d = _a.starDimension,
      starDimension = _d === void 0 ? '16px' : _d,
      _e = _a.numberOfStars,
      numberOfStars = _e === void 0 ? 5 : _e,
      _f = _a.svgIconViewBox,
      svgIconViewBox = _f === void 0 ? '0 0 16 16' : _f,
      _g = _a.svgIconPath,
      svgIconPath = _g === void 0 ? 'M8 .867l2.318 4.696 5.182.753-3.75 3.655.885 5.162L8 12.696l-4.635 2.437.885-5.162L.5 6.316l5.182-.753z' : _g,
      rating = _a.rating,
      rest = __rest(_a, ["starRatedColor", "starSpacing", "starDimension", "numberOfStars", "svgIconViewBox", "svgIconPath", "rating"]);

  return React.createElement(StarRatings, __assign({
    rating: rating,
    starRatedColor: starRatedColor,
    starSpacing: starSpacing,
    starDimension: starDimension,
    numberOfStars: numberOfStars,
    svgIconViewBox: svgIconViewBox,
    svgIconPath: svgIconPath
  }, rest));
};

export default StarRating;
//# sourceMappingURL=index.js.map
